//IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-regular-svg-icons";

import "../scss/Why.scss";

export const Why = () => {
  //
  const { t } = useTranslation();

  return (
    <main className='why'>
      <div className='container'>
        <div className='wrapper'>
          <h1 style={{ margin: 20 }}>{t("why:title")}</h1>
          <section>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: 48 }}>
                <FontAwesomeIcon icon={faSquareCheck} />
              </div>
              <h2>Brokers</h2>
              <p style={{ maxWidth: "40ch" }}>{t("why:p1")}</p>
            </div>

            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: 48 }}>
                <FontAwesomeIcon icon={faSquareCheck} />
              </div>
              <h2>Understanding</h2>
              <p style={{ maxWidth: "40ch" }}>{t("why:p2")}</p>
            </div>
          </section>
          <section>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: 48 }}>
                <FontAwesomeIcon icon={faSquareCheck} />
              </div>
              <h2>Communication</h2>
              <p style={{ maxWidth: "40ch" }}>{t("why:p3")}</p>
            </div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: 48 }}>
                <FontAwesomeIcon icon={faSquareCheck} />
              </div>
              <h2>Service</h2>
              <p style={{ maxWidth: "40ch" }}>{t("why:p4")}</p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};
